import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createUpdateAction } from "../../network/store/action/TagResponseAction";
import { updateMessage } from "../../redux/slice/toastSlice";
import {
  formUpdateData,
  updateFormInfo,
} from "../../redux/slice/formUpdateSlice";
import { API_CONFIG, API_HEADERS } from "../../network/config/ApiConfig";
import { CATGORY_API_PATH } from "../../network/config/apiPaths";
import axios from "axios";

const AddUpdateForm = (props) => {
  // TO get Callbacks
  const dispatch = useDispatch();
  const formData = useSelector(formUpdateData);
  const itemInfo = formData.item;

  // Page Form
  const [dataForm, setDataForm] = useState({
    name: "",
    categoryId: "",
  });

  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    fetchCategoryList();
    if (itemInfo) {
      let updateValues = {
        name: itemInfo.name,
        categoryId: itemInfo.catId,
      };
      setDataForm(updateValues);
    }

  }, []);

  const handleInputChanges = (e) => {
    setDataForm({
      ...dataForm,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmtClick = async () => {
    let requestBody = {
      name: dataForm.name,
      type: props.type
    };

    if (itemInfo != undefined) {
      requestBody.id = itemInfo.id;
    }

    await dispatch(createUpdateAction(requestBody)).then((response) => {
      if (response.status == true) {
        if (props.onSubmit) props.onSubmit();
      } else {
        dispatch(
          updateMessage({
            display: true,
            message: "Error While updating info",
          })
        );
      }
    });
  };

  const fetchCategoryList = async () => {
    let data = await axios.get(API_CONFIG.API_HOST + CATGORY_API_PATH.LIST_PATH, {
      headers: API_HEADERS
    })
    setCategoryList(data.data.result)
  }

  return (
    <>
      <div
        style={{
          position: "fixed",
          backgroundColor: "rgba(0,0,0,0.5)",
          width: "100%",
          height: "100%",
          zIndex: "999",
          overflow: "scroll",
        }}
      >
        <div className="d-flex align-item-center justify-content-center">
          <div className="col-md-8">
            <div className="container">
              <div className="row mt-5">
                <div className="col-md-5 card-1 p-5">
                  {itemInfo != undefined ? (
                    <h4 className="text-center-new ">Update Tag</h4>
                  ) : (
                    <h4 className="text-center-new"> Add Tag</h4>
                  )}

                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Tag Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={dataForm.name}
                        onChange={(e) => handleInputChanges(e)}
                      />

                      {
                        props.type == "STORE" && <>
                          <label>Category</label>
                          <select className="form-control" name="categoryId" value={dataForm.categoryId} onChange={handleInputChanges}>
                            <option>{"--Select Category--"}</option>
                            {
                              categoryList.map((obj, i) => {
                                return (
                                  <option value={obj.id} key={i}>{obj.name}</option>
                                )
                              })
                            }
                          </select>
                        </>
                      }

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: 20,
                        }}
                      >
                        <button
                          style={{ display: "flex", justifyContent: "center" }}
                          type="button"
                          className="btn btn-purple-bg"
                          onClick={() => onSubmtClick()}
                        >
                          Submit
                        </button>
                        <button
                          className="btn btn-white-bg"
                          onClick={() => {
                            dispatch(
                              updateFormInfo({
                                displayForm: false,
                                formData: {},
                              })
                            );
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUpdateForm;
